const divCalendarActionCard = {
  verification: 'Verificación',
  equipment: 'Equipo',
  place: 'Lugar',
  company: 'Empresa',
  accountable: 'Responsables',
  noAccountable: 'Sin Responsables',
  service: 'Servicio',
  serviceAction: 'Acción Creada por'
};

export default divCalendarActionCard;
